

const _registerCSSInterfaceWithDefaultTheme = _interopRequireDefault(require('./utils/registerCSSInterfaceWithDefaultTheme'));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _registerCSSInterfaceWithDefaultTheme.default)();
